import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useHistory } from "react-router";
import { Button, Row } from "react-bootstrap";
// import logosn from "../../assets/static/images/logo-sn.png";
import LoadingModal from "../../components/LoadingModal/LoadingModal";
import { login } from "../../redux/Authentication/actions";
import logoAfip from "./assets/afip.png";
import logoAnses from "./assets/anses.png";
import logoMiarg from "./assets/miArgentina.png";
import logoRenaper from "./assets/renaper.png";

import "./Login.css";

const Login = () => {
  const { loading } = useSelector(({ authentication }) => authentication);
  const dispatch = useDispatch();

  const history = useHistory();
  const params = new URLSearchParams(location.search);
  const token = params.get("token");

  useEffect(() => {
    const dataStorage = sessionStorage.getItem("sn-gestion-legal");

    if (!dataStorage) {
      try {
        if (params && token) {
          dispatch(login({ token }));
        }
      }
      catch (err) {
        console.error(err);
        window.location.replace("/");
      }
    } else {
      history.push("/home");
    }
  }, []);

  const handleSubmit = (e) => {
    // const VUELVE = "http://localhost:3000";
    const VUELVE = process.env.REACT_APP_VUELVE_URL || "https://stage--gestion-deudas.netlify.app";
    const REACT_APP_AUTH_URL = "https://wsrfa.sannicolasciudad.gob.ar/autenticar/logueo.php";

    // vlv: sitio web donde se recibe el resultado de la autenticación
    // fnt: servicio de logueo
    // afip: servicio AFIP
    // anses: servicio ANSES
    // miarg: servicio Mi Argentina
    // renaper: servicio Registro Nacional de Personas
    window.location.replace(`${REACT_APP_AUTH_URL}?fnt=${e}&vlv=${VUELVE}`);
  };

  return (
    <>
      <div className="login">
        <div className="login-container">
          <div className="login-contents">
            <Row>
              <span className="subtitle">Inicio de sesión</span>
            </Row>
            <Row className="mb-3">
              {/* <span style={{ marginBottom: 11 }}>Con Renaper</span> */}
              <Button
                onClick={() => handleSubmit("renaper")}
                variant='light'
                className='login-button'
              >
                <img src={logoRenaper} alt="renaper" />
              </Button>
            </Row>
            <Row className="mb-3">
              {/* <span style={{ marginBottom: 11 }}>Con AFIP</span> */}
              <Button
                onClick={() => handleSubmit("afip")}
                variant='light'
                className='login-button'
              >
                <img src={logoAfip} alt="afip" />
              </Button>
            </Row>
            <Row className="mb-3">
              {/* <span style={{ marginBottom: 11 }}>Con Mi Argentina</span> */}
              <Button
                onClick={() => handleSubmit("miarg")}
                variant='light'
                className='login-button'
              >
                <img src={logoMiarg} alt="miarg" />
              </Button>
            </Row>
            <Row className="mb-3">
              {/* <span style={{ marginBottom: 11 }}>Con ANSES</span> */}
              <Button
                onClick={() => handleSubmit("anses")}
                variant='light'
                className='login-button'
              >
                <img src={logoAnses} alt="anses" />
              </Button>
            </Row>
          </div>
        </div>
        <div className="login-image">
        </div>
      </div>
      <LoadingModal show={loading} loading={true} loging={true} />
    </>
  );
};

export default Login;
